import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { Stack, Typography } from '@mui/material';
import { useEllipsis } from '@Components/shared/styles/useEllipsis';
import TruncateText from '@Components/truncate-text/TruncateText';
import { useAvTransactionDrawer } from '@Modal/hooks/transaction/useAvTransactionDrawer';

const useSx = () => {
  return {
    id: {
      fontWeight: '700',
      fontSize: '18px',
      lineHeight: '28px',
      marginLeft: '',
    },
  } satisfies Record<string, SystemStyleObject<Theme>>;
};

export const SetupAvTransactionDrawerHeader = () => {
  const ellipsis = useEllipsis();
  const styles = useSx();
  const { selectedAvTransactionData } = useAvTransactionDrawer();

  return (
    <Stack direction="row" justifyContent="space-between" alignContent="center">
      <Stack spacing={1} direction="row" sx={{ ...ellipsis }}>
        <Typography variant="h6">Transaction:</Typography>{' '}
        <TruncateText text={selectedAvTransactionData._id} maxLength={8} textStyles={styles.id} />
      </Stack>
    </Stack>
  );
};
